import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

const Wrapper = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_70 },
      },
    },
  }) => css`
    margin: 0 8px;
    color: ${grey_70};
    font-size: 12px;
    line-height: 15px;

    /* On mobile, dates must be always displayed in 2 lines, without any divider */
    ${mobileCSS(css`
      display: none;
    `)}
  `}
`

const Divider: FunctionComponent = () => <Wrapper>|</Wrapper>

export default Divider
